/** How pick-one dropdowns look, chosen by each person (user_preference('app').picker):
 * standard = the browser's own select (the phone's full list), sleek = a small menu under the field,
 * sleeker = the choices as chips in the form (short lists only). */
import { createContext } from 'react'

export const PICKER_STYLES = ['standard', 'sleek', 'sleeker'] as const
export type PickerStyle = (typeof PICKER_STYLES)[number]

export function isPickerStyle(value: unknown): value is PickerStyle {
  return typeof value === 'string' && (PICKER_STYLES as readonly string[]).includes(value)
}

export const PickerStyleContext = createContext<PickerStyle>('standard')
